import * as ko from "knockout";
import entityBase from "entityBase";

export class c_model_info extends entityBase {
  color: KnockoutObservable<string>;

  constructor(item?: any) {
    super();
    this.color = ko.observable(item.color);
  }
}
